export default {
    parts: [],
    baseStyle: (props) => ({
        container: {
            width: { base: '100%' },
            height: { base: '100%' }
        }
    })
}
